module.exports = "/static/assets/c3b4884ed609e50774104c3fd627b89e.png";